<section
  *ngIf="promoImageLink"
  [appStoryblokEditable]="promoImageLink._editable"
  class="promo-image-wrapper"
>
  <a class="promo-image-link" (click)="navigateToLink()" appDisableClickEvent>
    <img
      loading="lazy"
      class="promo-image-link__image"
      [src]="getImageSrc(promoImageLink['smartphone'])"
      alt="promo-image-link"
    />

    <div class="promo-image-link__link">
      {{ promoImageLink.text }}
      <span class="promo-image-link__link__arrow">
        <mm-icon name="chevron-right"></mm-icon>
      </span>
    </div>
  </a>
</section>
